var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _g, _path87, _path88, _path89, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 491,
    height: 495,
    viewBox: "0 0 491 495",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M404.601 438.893C404.197 438.894 403.8 438.788 403.45 438.588C403.099 438.387 402.808 438.098 402.604 437.75C402.444 437.492 402.338 437.204 402.293 436.904C402.248 436.604 402.264 436.298 402.341 436.004C402.414 435.707 402.545 435.428 402.729 435.184C402.913 434.94 403.144 434.735 403.409 434.583L478.695 389.784C480.004 389.005 481.086 387.897 481.832 386.57C482.578 385.244 482.963 383.745 482.947 382.224C482.931 380.703 482.516 379.212 481.743 377.901C480.97 376.59 479.865 375.505 478.54 374.753L375.75 316.529C375.228 316.231 374.844 315.741 374.679 315.163C374.514 314.586 374.582 313.968 374.867 313.44C375.072 313.083 375.367 312.787 375.723 312.581C376.079 312.374 376.483 312.266 376.895 312.266C377.297 312.267 377.692 312.374 378.04 312.575L480.831 370.814C482.865 371.965 484.56 373.628 485.747 375.638C486.935 377.648 487.573 379.934 487.598 382.267C487.623 384.6 487.034 386.899 485.89 388.933C484.746 390.968 483.087 392.668 481.079 393.862L405.793 438.661C405.423 438.841 405.012 438.921 404.601 438.893Z",
    fill: "#9094CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M404.894 432.791C403.706 432.796 402.548 432.41 401.601 431.693C400.653 430.977 399.968 429.969 399.651 428.825C399.334 427.681 399.403 426.465 399.847 425.365C400.291 424.264 401.086 423.34 402.108 422.734L477.41 377.935C478.256 377.433 478.955 376.717 479.437 375.861C479.919 375.004 480.166 374.036 480.156 373.053C480.145 372.071 479.875 371.108 479.374 370.263C478.873 369.417 478.159 368.717 477.302 368.234L374.511 309.979C373.866 309.643 373.296 309.18 372.834 308.619C372.372 308.058 372.028 307.409 371.823 306.712C371.618 306.016 371.556 305.285 371.64 304.563C371.724 303.842 371.953 303.145 372.313 302.514C372.672 301.883 373.156 301.33 373.735 300.89C374.313 300.449 374.974 300.129 375.679 299.95C376.384 299.77 377.118 299.734 377.838 299.843C378.557 299.953 379.247 300.206 379.866 300.587L482.657 358.826C485.159 360.246 487.244 362.296 488.705 364.772C490.165 367.247 490.95 370.061 490.982 372.934C491.013 375.806 490.289 378.637 488.883 381.144C487.477 383.65 485.437 385.745 482.966 387.219L407.665 432.019C406.83 432.525 405.871 432.792 404.894 432.791Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M404.601 428.466C404.197 428.466 403.8 428.361 403.45 428.16C403.099 427.96 402.808 427.671 402.604 427.322C402.444 427.064 402.338 426.777 402.293 426.477C402.248 426.177 402.264 425.87 402.341 425.577C402.414 425.28 402.545 425.001 402.729 424.757C402.913 424.513 403.144 424.308 403.409 424.156L478.695 379.356C480.004 378.578 481.086 377.469 481.832 376.143C482.578 374.816 482.963 373.318 482.947 371.797C482.931 370.275 482.516 368.785 481.743 367.474C480.97 366.163 479.865 365.078 478.54 364.326L375.75 306.025C375.228 305.726 374.844 305.236 374.679 304.659C374.514 304.082 374.582 303.463 374.867 302.935C375.072 302.579 375.367 302.282 375.723 302.076C376.079 301.87 376.483 301.761 376.895 301.761C377.297 301.763 377.692 301.869 378.04 302.07L480.831 360.309C482.865 361.46 484.56 363.124 485.747 365.134C486.935 367.143 487.573 369.429 487.598 371.762C487.623 374.095 487.034 376.394 485.89 378.429C484.746 380.464 483.087 382.163 481.079 383.358L405.793 428.157C405.43 428.363 405.019 428.47 404.601 428.466Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M404.292 427.23C404.077 427.229 403.866 427.173 403.679 427.068C403.492 426.962 403.335 426.81 403.224 426.627C403.056 426.343 403.006 426.005 403.084 425.685C403.122 425.526 403.192 425.376 403.291 425.246C403.389 425.116 403.514 425.007 403.657 424.928L478.943 380.129C480.418 379.253 481.637 378.006 482.477 376.512C483.317 375.018 483.75 373.33 483.731 371.617C483.712 369.904 483.243 368.227 482.37 366.752C481.497 365.277 480.251 364.056 478.757 363.213L375.966 304.974C375.681 304.812 375.472 304.544 375.385 304.228C375.298 303.912 375.34 303.575 375.502 303.29C375.608 303.097 375.765 302.936 375.956 302.824C376.147 302.713 376.364 302.655 376.586 302.657C376.797 302.653 377.006 302.707 377.189 302.811L479.98 361.066C481.849 362.123 483.407 363.651 484.498 365.498C485.59 367.345 486.177 369.445 486.2 371.589C486.224 373.733 485.683 375.845 484.632 377.715C483.582 379.585 482.057 381.147 480.212 382.245L404.926 427.044C404.736 427.164 404.516 427.228 404.292 427.23Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M436.843 418.95C436.843 422.039 435.759 424.295 433.995 425.361C433.995 425.361 413.625 444.47 413.548 444.516C410.684 446.061 412.511 442.585 408.177 440.191C399.432 435.371 392.358 423.723 392.358 414.146C392.358 409.418 387.715 409.388 390.578 407.796L419.6 400.768C421.473 399.763 423.965 399.933 426.72 401.525C429.659 403.432 432.107 406.004 433.866 409.031C435.624 412.058 436.644 415.456 436.843 418.95Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M400.561 407.672C391.058 402.204 383.35 406.576 383.35 417.467C383.35 428.357 391.089 441.627 400.561 447.096C410.034 452.564 417.773 448.193 417.773 437.302C417.773 426.411 410.065 413.11 400.561 407.672ZM400.561 441.04C393.983 437.24 388.643 428.064 388.643 420.525C388.643 412.987 393.983 409.943 400.561 413.744C404.021 415.99 406.902 419.018 408.973 422.582C411.043 426.146 412.244 430.146 412.48 434.258C412.48 441.751 407.14 444.748 400.561 440.994V441.04Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M411.304 449.131C417.983 445.234 417.913 432.712 411.148 421.163C404.384 409.614 393.486 403.411 386.807 407.308C380.128 411.204 380.198 423.726 386.962 435.275C393.727 446.824 404.625 453.027 411.304 449.131Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M402.191 444.646C406.8 441.972 406.778 433.35 402.14 425.389C397.503 417.428 390.006 413.143 385.397 415.817C380.787 418.492 380.81 427.114 385.448 435.075C390.085 443.036 397.581 447.321 402.191 444.646Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M393.456 428.96C392.553 428.362 391.804 427.562 391.266 426.623C390.729 425.684 390.418 424.633 390.36 423.553C390.36 421.56 391.769 420.757 393.456 421.761C394.36 422.358 395.111 423.157 395.649 424.097C396.187 425.036 396.496 426.088 396.552 427.168C396.598 429.161 395.19 429.949 393.456 428.96Z",
    fill: "#4D4C63"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M404.213 435.757C403.31 435.159 402.56 434.359 402.023 433.42C401.485 432.481 401.175 431.43 401.117 430.35C401.117 428.357 402.526 427.554 404.213 428.558C405.115 429.156 405.865 429.957 406.403 430.895C406.94 431.834 407.25 432.885 407.308 433.965C407.355 435.958 405.946 436.761 404.213 435.757Z",
    fill: "#4D4C63"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M399.306 408.352C394.493 405.571 390.143 405.34 387.017 407.194C390.112 405.494 394.369 405.803 399.059 408.507C408.562 413.975 416.27 427.245 416.27 438.136C416.27 443.496 414.397 447.281 411.364 449.088C414.552 447.343 416.534 443.496 416.534 437.981C416.534 427.106 408.825 413.852 399.306 408.352Z",
    fill: "url(#paint6_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    d: "M390.761 413.635C388.533 414.84 387.14 417.513 387.14 421.359C387.375 425.472 388.576 429.472 390.647 433.036C392.717 436.6 395.598 439.627 399.058 441.874C402.417 443.805 405.45 443.96 407.617 442.647C405.466 443.805 402.54 443.589 399.305 441.735C395.849 439.487 392.97 436.458 390.903 432.894C388.835 429.331 387.636 425.332 387.403 421.22C387.403 417.513 388.672 414.902 390.761 413.635Z",
    fill: "url(#paint7_radial)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.906 317.642L281.488 285.541C286.566 282.739 292.295 281.322 298.096 281.432C300.533 281.462 302.959 281.773 305.325 282.359C307.54 282.936 309.672 283.792 311.671 284.908L373.583 321.071C373.583 321.071 375.379 322.122 375.425 322.168C377.631 323.38 379.446 325.193 380.66 327.394C381.874 329.595 382.436 332.096 382.282 334.604C382.004 339.655 378.196 345.417 372.717 348.507L321.298 397.94C316.322 400.692 310.719 402.118 305.03 402.081C300.363 402.194 295.747 401.086 291.642 398.867L196.296 343.1C194.079 341.974 192.21 340.268 190.888 338.166C189.566 336.063 188.841 333.641 188.789 331.159C188.82 325.891 192.117 320.963 197.906 317.642Z",
    fill: "#9FA5D0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.261 317.704L281.843 285.603C286.888 282.828 292.585 281.452 298.343 281.617C303.06 281.678 307.685 282.938 311.778 285.279L373.304 321.164C373.428 321.164 375.038 322.199 375.13 322.276C377.235 323.513 378.917 325.353 379.958 327.558C380.999 329.762 381.35 332.228 380.966 334.635C380.47 339.161 376.322 345.448 371.323 348.291L320.848 397.338C315.998 400.014 310.541 401.403 304.999 401.37C300.445 401.483 295.939 400.419 291.92 398.281L196.651 341.926C194.543 340.856 192.766 339.234 191.51 337.234C190.253 335.235 189.564 332.932 189.516 330.572C189.562 325.567 192.72 320.902 198.261 317.704Z",
    fill: "#8F95BB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.27
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M198.631 317.765L282.214 285.68C287.238 282.919 292.92 281.574 298.652 281.787C301.052 281.894 303.431 282.283 305.741 282.946C307.884 283.648 309.956 284.548 311.932 285.634L373.086 321.396C373.257 321.504 374.758 322.4 374.882 322.508C379.525 325.52 380.531 329.985 379.711 334.866C379.045 338.852 374.371 345.68 369.991 348.244L320.46 396.766C315.723 399.379 310.394 400.735 304.982 400.706C300.545 400.828 296.154 399.79 292.244 397.693L197.022 340.721C195.013 339.704 193.321 338.16 192.126 336.255C190.931 334.349 190.28 332.155 190.242 329.908C190.32 325.258 193.338 320.824 198.631 317.765Z",
    fill: "#7F84A7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199.035 317.843L282.618 285.742C287.619 283.005 293.281 281.701 298.978 281.973C301.362 282.109 303.721 282.529 306.005 283.224C308.112 283.991 310.156 284.921 312.119 286.005L372.933 321.535C373.165 321.659 374.481 322.493 374.713 322.647C379.356 325.737 380.687 330.371 378.536 334.882C378.536 338.404 372.561 345.696 368.723 347.967L320.137 396.041C315.527 398.605 310.338 399.95 305.061 399.949C300.749 400.069 296.481 399.062 292.678 397.029L197.41 339.563C195.504 338.614 193.897 337.158 192.767 335.357C191.636 333.555 191.026 331.477 191.002 329.352C191.079 324.934 193.943 320.747 199.035 317.843Z",
    fill: "#6F7492"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199.359 317.905L282.941 285.804C286.443 283.842 290.314 282.626 294.31 282.232C298.306 281.839 302.341 282.276 306.159 283.517C308.228 284.34 310.244 285.289 312.195 286.36L372.669 321.72C372.963 321.89 374.217 322.663 374.449 322.848C378.922 325.938 379.928 330.696 377.25 335.006C377.25 338.095 370.641 345.927 367.344 347.812L319.764 395.453C315.272 397.914 310.23 399.2 305.106 399.192C300.9 399.32 296.734 398.351 293.018 396.38L197.749 338.342C193.725 336.025 191.558 332.518 191.713 328.703C191.821 324.609 194.545 320.67 199.359 317.905Z",
    fill: "#5F637D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199.716 317.966L283.299 285.865C288.253 283.171 293.875 281.943 299.504 282.328C301.855 282.561 304.168 283.08 306.392 283.873C307.445 284.212 311.5 286.298 312.367 286.792L372.5 321.952C372.84 322.153 374.047 322.863 374.249 323.095C375.244 323.702 376.095 324.521 376.739 325.492C377.383 326.463 377.806 327.564 377.977 328.716C378.148 329.868 378.064 331.044 377.73 332.16C377.396 333.276 376.82 334.306 376.044 335.175C376.044 337.693 368.8 346.128 366.061 347.704L319.363 394.882C314.996 397.279 310.091 398.533 305.107 398.528C301.016 398.658 296.961 397.721 293.344 395.809L198.106 337.153C194.283 334.944 192.302 331.653 192.441 328.085C192.581 324.254 195.15 320.608 199.716 317.966Z",
    fill: "#505368"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.64
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M200.087 318.074L283.67 285.974C287.124 283.992 290.973 282.796 294.944 282.47C298.914 282.144 302.908 282.697 306.639 284.089C307.475 284.367 311.84 286.684 312.537 287.07L372.391 322.06C372.992 322.405 373.571 322.787 374.124 323.203C378.396 326.401 378.66 331.205 374.914 335.206C374.914 337.23 367.035 346.205 364.837 347.457L319.099 394.187C314.855 396.516 310.09 397.739 305.246 397.74C301.269 397.875 297.326 396.97 293.808 395.114L198.539 335.963C194.918 333.878 193.06 330.788 193.23 327.482C193.401 324.176 195.753 320.531 200.087 318.074Z",
    fill: "#404253"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.73
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M200.443 318.075L284.025 285.974C288.933 283.319 294.516 282.169 300.076 282.668C302.393 282.946 304.666 283.517 306.84 284.367C307.459 284.583 312.133 287.132 312.644 287.457L372.111 322.215C372.705 322.569 373.279 322.955 373.83 323.373C377.978 326.617 377.869 331.453 373.597 335.315C373.597 336.859 365.084 346.345 363.444 347.287L318.634 393.631C314.511 395.886 309.886 397.07 305.184 397.076C301.323 397.212 297.494 396.344 294.07 394.558L198.802 334.836C195.381 332.858 193.679 329.985 193.864 326.926C194.05 323.868 196.372 320.454 200.443 318.075Z",
    fill: "#30323E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.82
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M200.814 318.167L284.396 286.066C289.289 283.438 294.857 282.33 300.385 282.884C302.682 283.202 304.928 283.809 307.072 284.691C307.49 284.846 312.458 287.626 312.814 287.781L371.926 322.353C372.525 322.691 373.095 323.078 373.628 323.512C377.683 326.802 377.204 331.684 372.374 335.376C372.374 336.396 363.242 346.452 362.143 347.07L318.293 392.904C314.285 395.087 309.796 396.239 305.23 396.257C301.467 396.416 297.729 395.579 294.395 393.831L199.127 333.584C195.892 331.715 194.344 329.058 194.483 326.246C194.623 323.435 196.975 320.376 200.814 318.167Z",
    fill: "#20212A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.91
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M201.172 318.229L284.754 286.144C289.615 283.525 295.16 282.447 300.65 283.054C302.933 283.407 305.16 284.057 307.275 284.985C307.476 285.062 312.77 288.075 312.94 288.183L371.757 322.555C372.358 322.888 372.923 323.281 373.444 323.729C377.391 327.05 376.54 331.962 371.184 335.516C367.946 339.494 364.505 343.305 360.876 346.932L317.955 392.302C314.075 394.418 309.73 395.538 305.309 395.562C301.677 395.707 298.07 394.903 294.846 393.229L199.577 332.395C196.482 330.649 195.135 328.193 195.367 325.629C195.6 323.064 197.581 320.299 201.172 318.229Z",
    fill: "#101115"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M295.2 392.611L199.932 331.205C194.19 327.899 194.902 322.122 201.48 318.306L285.062 286.205C291.687 282.389 301.717 281.972 307.444 285.278L371.555 322.709C377.297 326.015 376.569 331.792 370.007 335.608L317.644 391.684C310.957 395.5 300.927 395.917 295.2 392.611Z",
    fill: "black"
  })))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M295.201 392.472L199.933 337.245C198.854 336.757 197.927 335.99 197.246 335.023C196.565 334.055 196.157 332.924 196.063 331.746C196.063 331.746 196.063 318.445 196.063 318.383C196.063 315.881 197.967 320.237 201.543 318.167L285.125 286.066C291.75 282.25 301.78 281.833 307.507 285.139L371.54 322.585C373.459 323.682 374.837 319.001 375.332 320.484C375.503 320.994 375.332 333.738 375.41 334.264C375.41 336.828 373.614 339.547 369.93 341.663L317.567 391.545C310.958 395.314 300.928 395.778 295.201 392.472Z",
    fill: "url(#paint8_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M295.2 379.233L199.932 324.022C194.19 320.716 194.902 314.939 201.48 311.123L285.062 279.022C291.687 275.206 301.717 274.789 307.444 278.095L371.477 315.526C377.22 318.847 376.492 324.609 369.929 328.425L317.582 378.322C310.957 382.137 300.927 382.539 295.2 379.233Z",
    fill: "url(#paint9_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M371.555 315.526L307.522 278.095C301.795 274.789 291.765 275.206 285.141 279.022L243.024 295.196C243.435 295.526 243.87 295.826 244.325 296.092L339.593 351.319C341.022 352.105 342.561 352.672 344.159 353.002L369.946 328.425C376.57 324.609 377.298 318.847 371.555 315.526Z",
    fill: "url(#paint10_linear)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M369.945 327.235L317.582 377.117C310.957 380.932 300.928 381.349 295.201 378.044L199.932 322.817C198.931 322.343 198.06 321.635 197.391 320.753C196.723 319.87 196.278 318.84 196.094 317.75C195.8 320.083 197.053 322.384 199.932 324.022L295.201 379.635C300.928 382.941 310.957 382.523 317.582 378.708L369.945 328.394C373.83 326.169 375.656 323.265 375.378 320.577C375.084 322.941 373.257 325.335 369.945 327.235Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M419.661 379.542L185.692 244.619C173.727 237.714 164.022 219.223 164.022 203.311V24.7169C164.022 8.80543 173.727 1.54487 185.692 8.37288L419.661 143.311C431.625 150.201 441.33 168.692 441.33 184.604V363.198C441.315 379.125 431.625 386.432 419.661 379.542Z",
    fill: "url(#paint11_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M422.446 367.106L191.821 234.099C182.193 227.997 176.234 215.793 176.234 203.311V23.5431C176.238 22.8707 176.418 22.211 176.758 21.6302C177.098 21.0495 177.584 20.5682 178.169 20.2347C178.755 19.9012 179.417 19.7273 180.091 19.7305C180.765 19.7337 181.426 19.9138 182.008 20.2527L182.689 20.6389L413.608 153.816C425.062 160.412 429.179 172.122 429.179 184.604V363.801C429.181 364.525 428.991 365.236 428.63 365.864C428.268 366.491 427.748 367.013 427.12 367.376C426.493 367.739 425.781 367.931 425.055 367.933C424.33 367.934 423.617 367.745 422.988 367.385L422.446 367.106Z",
    fill: "url(#paint12_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M413.577 153.816L182.657 20.6387L181.976 20.2525C181.394 19.9097 180.731 19.7264 180.055 19.7213C179.379 19.7162 178.714 19.8893 178.126 20.2232C177.539 20.5571 177.05 21.04 176.71 21.6229C176.369 22.2058 176.189 22.8682 176.188 23.5429V203.311C176.188 215.793 182.147 228.028 191.774 234.099L422.4 367.106L422.91 367.4C423.539 367.76 424.252 367.949 424.977 367.948C425.703 367.946 426.415 367.754 427.042 367.391C427.67 367.028 428.19 366.506 428.552 365.879C428.913 365.251 429.103 364.54 429.102 363.816V184.619C429.148 172.122 425.015 160.412 413.577 153.816ZM426.718 363.816C426.718 364.04 426.673 364.263 426.587 364.47C426.5 364.677 426.374 364.865 426.214 365.023C426.054 365.181 425.864 365.306 425.656 365.39C425.448 365.475 425.225 365.517 425 365.515C424.705 365.519 424.415 365.439 424.164 365.283L192.997 231.998C184.298 226.483 178.633 215.206 178.633 203.311V23.5429C178.633 23.3583 178.67 23.1755 178.74 23.005C178.811 22.8344 178.915 22.6794 179.046 22.5489C179.176 22.4184 179.332 22.3148 179.503 22.2442C179.673 22.1735 179.857 22.1371 180.042 22.1371C180.292 22.1457 180.536 22.2146 180.754 22.338L412.354 155.87C424.226 162.698 426.718 175.242 426.718 184.557V363.816Z",
    fill: "#AFB6E5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M429.66 137.534L195.661 2.59534C190.924 -0.123507 186.544 -0.633286 182.984 0.741586C182.535 0.926961 172.66 6.64272 172.242 6.92078C175.941 5.11337 180.616 5.45322 185.724 8.46558L419.692 143.404C431.657 150.294 441.362 168.785 441.362 184.696V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.948L444.581 374.398C448.699 371.509 451.253 365.608 451.253 357.405V178.841C451.33 162.915 441.594 144.423 429.66 137.534Z",
    fill: "url(#paint13_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M429.444 137.657L195.475 2.71887C190.739 2.85655e-05 186.358 -0.50975 182.798 0.865121C182.349 1.03505 172.66 6.64267 172.242 6.87439C175.941 5.06697 180.616 5.40683 185.724 8.41919L419.692 143.357C431.657 150.247 441.362 168.738 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.947C434.01 380.793 444.21 374.691 444.473 374.506C448.59 371.632 451.16 365.731 451.16 357.513V178.95C451.113 163.038 441.408 144.547 429.444 137.657Z",
    fill: "url(#paint14_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M429.273 137.765L195.289 2.84227C190.553 0.107979 186.188 -0.386364 182.613 0.988507C182.164 1.15844 172.66 6.64248 172.242 6.8742C175.941 5.06679 180.616 5.40664 185.724 8.419L419.692 143.357C431.657 150.247 441.362 168.738 441.362 184.65V363.198C441.362 373.131 437.585 379.711 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.947C434.01 380.793 444.04 374.768 444.303 374.629C448.405 371.756 450.974 365.855 450.974 357.636V179.042C450.927 163.162 441.223 144.67 429.273 137.765Z",
    fill: "url(#paint15_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M429.088 137.889L195.103 2.93553C190.46 0.201232 186.002 -0.293099 182.442 1.08177C181.978 1.2517 172.66 6.61215 172.242 6.84387C175.941 5.03645 180.616 5.37631 185.724 8.38867L419.692 143.327C431.657 150.217 441.362 168.708 441.362 184.619V363.198C441.362 373.131 437.585 379.712 431.843 381.597C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 443.854 374.939 444.117 374.769C448.234 371.895 450.788 365.979 450.788 357.776V179.197C450.742 163.27 441.052 144.779 429.088 137.889Z",
    fill: "url(#paint16_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M428.902 138.012L194.933 3.07386C190.197 0.355009 185.817 -0.15477 182.257 1.2201C181.808 1.40548 172.66 6.64235 172.242 6.87407C175.941 5.06666 180.616 5.40651 185.724 8.41887L419.692 143.357C431.657 150.247 441.362 168.738 441.362 184.65V363.197C441.362 373.13 437.585 379.711 431.843 381.596C432.524 381.552 433.181 381.329 433.747 380.947C434.01 380.793 443.668 375.061 443.931 374.876C448.049 372.003 450.603 366.086 450.603 357.883V179.32C450.556 163.393 440.867 144.902 428.902 138.012Z",
    fill: "url(#paint17_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M428.716 138.136L194.748 3.19788C190.011 0.479032 185.631 -0.0307466 182.071 1.34412C181.622 1.51405 172.66 6.64279 172.242 6.87451C175.941 5.06709 180.616 5.40695 185.724 8.41931L419.692 143.358C431.657 150.247 441.362 168.739 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.948L443.746 375C447.863 372.111 450.432 366.21 450.432 358.007V179.429C450.386 163.594 440.681 145.057 428.716 138.136Z",
    fill: "url(#paint18_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M428.531 138.245L194.562 3.32176C189.825 0.587463 185.461 0.0931317 181.885 1.468C181.436 1.63793 172.598 6.64308 172.242 6.8748C175.941 5.06739 180.616 5.40724 185.724 8.4196L419.692 143.358C431.657 150.248 441.362 168.739 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.597C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 443.312 375.294 443.56 375.109C447.677 372.235 450.246 366.334 450.246 358.116V179.552C450.2 163.595 440.495 145.15 428.531 138.245Z",
    fill: "url(#paint19_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M428.359 138.368L194.391 3.4453C189.67 0.711006 185.289 0.216663 181.729 1.59153C181.265 1.76146 172.675 6.64304 172.257 6.87476C175.956 5.06734 180.631 5.4072 185.738 8.41956L419.707 143.358C431.672 150.248 441.377 168.739 441.377 184.65V363.198C441.377 373.131 437.6 379.712 431.857 381.597C432.539 381.553 433.196 381.329 433.761 380.948C434.024 380.793 443.141 375.417 443.404 375.232C447.506 372.359 450.075 366.442 450.075 358.239V179.676C450.013 163.749 440.309 145.258 428.359 138.368Z",
    fill: "url(#paint20_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M428.113 138.491L194.206 3.56861C189.469 0.834316 185.089 0.324522 181.529 1.69939C181.065 1.88477 172.66 6.64276 172.242 6.87448C175.941 5.06707 180.616 5.40692 185.724 8.41928L419.692 143.357C431.657 150.247 441.362 168.739 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 442.941 375.541 443.204 375.355C447.321 372.482 449.875 366.565 449.875 358.363V179.799C449.782 163.872 440.139 145.381 428.113 138.491Z",
    fill: "url(#paint21_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M427.989 138.615L194.02 3.67689C189.284 0.958045 184.903 0.448254 181.343 1.82313C180.895 2.0085 172.66 6.64291 172.242 6.87463C175.941 5.06721 180.616 5.40707 185.724 8.41942L419.692 143.358C431.657 150.247 441.362 168.739 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.597C432.524 381.553 433.181 381.329 433.747 380.948L443.034 375.479C447.151 372.59 449.705 366.689 449.705 358.486V179.908C449.643 163.996 439.953 145.505 427.989 138.615Z",
    fill: "url(#paint22_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M427.803 138.739L193.834 3.80042C189.098 1.08157 184.718 0.571792 181.158 1.94666C180.709 2.11659 172.66 6.58106 172.242 6.87458C175.941 5.06716 180.616 5.40702 185.724 8.41938L419.692 143.358C431.657 150.247 441.362 168.739 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 442.569 375.773 442.832 375.587C446.95 372.714 449.519 366.813 449.519 358.594V180.031C449.473 164.12 439.768 145.628 427.803 138.739Z",
    fill: "url(#paint23_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M427.617 138.877L193.649 3.92381C188.912 1.18951 184.547 0.695183 180.972 2.07005C180.523 2.23998 172.66 6.70445 172.242 6.87438C175.941 5.06697 180.616 5.40682 185.724 8.41918L419.692 143.357C431.657 150.247 441.362 168.738 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 442.399 375.896 442.647 375.711C446.764 372.837 449.333 366.921 449.333 358.718V180.154C449.287 164.243 439.582 145.752 427.617 138.877Z",
    fill: "url(#paint24_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M427.447 138.97L193.463 4.04711C188.819 1.31281 184.362 0.818478 180.802 2.1779C180.337 2.36328 172.66 6.64237 172.242 6.8123C175.941 5.00488 180.616 5.34474 185.724 8.3571L419.692 143.295C431.657 150.185 441.362 168.676 441.362 184.588V363.197C441.362 373.131 437.585 379.711 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.947C434.01 380.793 442.213 376.019 442.476 375.834C446.594 372.961 449.148 367.044 449.148 358.841V180.278C449.101 164.351 439.412 145.86 427.447 138.97Z",
    fill: "url(#paint25_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M427.261 139.094L193.293 4.15541C188.556 1.43656 184.176 0.926769 180.616 2.30164C180.167 2.48702 172.66 6.64253 172.242 6.93604C175.941 5.12862 180.616 5.46848 185.724 8.48084L419.692 143.419C431.657 150.309 441.362 168.8 441.362 184.712V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.947C434.01 380.793 442.027 376.143 442.291 375.958C446.408 373.084 448.962 367.168 448.962 358.965V180.402C448.915 164.475 439.226 145.983 427.261 139.094Z",
    fill: "url(#paint26_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M427.076 139.217L193.107 4.27894C188.371 1.5601 183.99 1.0503 180.43 2.42518C179.981 2.5951 172.691 6.64249 172.242 6.87421C175.941 5.06679 180.616 5.40665 185.724 8.419L419.692 143.357C431.657 150.247 441.362 168.738 441.362 184.65V363.198C441.362 373.131 437.585 379.711 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.947C434.01 380.793 441.842 376.313 442.105 376.066C446.222 373.192 448.776 367.291 448.776 359.073V180.587C448.73 164.598 439.04 146.107 427.076 139.217Z",
    fill: "url(#paint27_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M426.89 139.325L192.921 4.47996C188.185 1.74567 183.804 1.25133 180.244 2.62621C179.796 2.79613 172.66 6.71992 172.242 6.95164C175.941 5.14422 180.616 5.48408 185.724 8.49644L419.692 143.435C431.657 150.324 441.362 168.816 441.362 184.727V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 441.656 376.313 441.919 376.19C446.036 373.316 448.606 367.415 448.606 359.197V180.587C448.559 164.722 438.855 146.231 426.89 139.325Z",
    fill: "url(#paint28_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M426.719 139.449L192.735 4.47996C188.014 1.74567 183.634 1.25133 180.059 2.62621C179.61 2.79613 172.66 6.59633 172.242 6.82805C175.941 5.02064 180.616 5.36049 185.724 8.37285L419.692 143.311C431.657 150.201 441.362 168.692 441.362 184.604V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 441.486 376.499 441.749 376.313C445.851 373.44 448.42 367.523 448.42 359.32V180.757C448.374 164.83 438.669 146.339 426.719 139.449Z",
    fill: "url(#paint29_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M426.565 139.572L192.55 4.64966C187.829 1.91536 183.448 1.40558 179.888 2.78045C179.424 2.96583 172.66 6.64245 172.242 6.87417C175.941 5.06676 180.616 5.40661 185.724 8.41897L419.692 143.357C431.657 150.247 441.362 168.738 441.362 184.65V363.198C441.362 373.131 437.585 379.711 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.947C434.01 380.793 441.3 376.622 441.486 376.437C445.603 373.563 448.157 367.647 448.157 359.444V180.88C448.234 164.953 438.498 146.462 426.565 139.572Z",
    fill: "url(#paint30_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M426.348 139.697L192.379 4.75843C187.643 2.03958 183.263 1.5298 179.703 2.90467C179.254 3.0746 172.66 6.64309 172.242 6.8748C175.941 5.06739 180.616 5.40725 185.724 8.4196L419.692 143.358C431.657 150.248 441.362 168.739 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.597C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 441.114 376.731 441.377 376.561C445.495 373.672 448.049 367.771 448.049 359.568V180.989C448.002 165.139 438.313 146.602 426.348 139.697Z",
    fill: "url(#paint31_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M426.162 139.82L192.194 4.88197C187.457 2.16312 183.077 1.65333 179.517 3.0282C179.068 3.19813 172.66 6.64304 172.242 6.87476C175.941 5.06735 180.616 5.4072 185.724 8.41956L419.692 143.358C431.657 150.248 441.362 168.739 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.597C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 440.929 376.854 441.192 376.669C445.309 373.795 447.878 367.894 447.878 359.676V181.113C447.832 165.139 438.127 146.71 426.162 139.82Z",
    fill: "url(#paint32_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M425.977 139.928L192.008 5.00535C187.272 2.27106 182.907 1.77673 179.331 3.1516C178.882 3.32152 172.66 6.64285 172.242 6.87457C175.941 5.06715 180.616 5.40701 185.724 8.41937L419.692 143.358C431.657 150.247 441.362 168.739 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.948C434.01 380.793 440.758 376.978 441.006 376.792C445.123 373.919 447.693 368.002 447.693 359.799V181.236C447.646 165.325 437.941 146.833 425.977 139.928Z",
    fill: "url(#paint33_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M425.806 140.051L191.822 5.12865C187.179 2.39436 182.721 1.90002 179.161 3.25944C178.697 3.44482 172.66 6.64256 172.242 6.87428C175.941 5.06687 180.616 5.40672 185.724 8.41908L419.692 143.357C431.657 150.247 441.362 168.738 441.362 184.65V363.198C441.362 373.131 437.585 379.712 431.843 381.596C432.524 381.553 433.181 381.329 433.747 380.947C434.01 380.793 440.572 377.101 440.836 376.915C444.937 374.042 447.507 368.126 447.507 359.923V181.359C447.46 165.432 437.755 146.941 425.806 140.051Z",
    fill: "url(#paint34_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M420.699 142.786L186.73 7.86325C181.823 5.03627 177.319 4.63462 173.682 6.19486C177.342 5.78561 181.032 6.64759 184.129 8.63565L418.098 143.512C430.063 150.402 439.768 168.893 439.768 184.805V363.461C439.768 372.853 436.378 379.218 431.146 381.473C437.833 380.407 442.368 373.564 442.368 362.688V184.094C442.368 168.229 432.663 149.691 420.699 142.786Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5457 294.547C51.698 296.097 49.1882 298.197 47.1627 300.726H44.4385V317.842H44.5159C44.8564 321.38 47.1626 324.717 51.5894 327.266L172.319 381.612L182.303 377.07V361.468L54.5457 294.547Z",
    fill: "url(#paint35_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M182.256 361.684C170.044 368.728 151.563 369.501 140.976 363.399L51.5892 311.895C41.0021 305.809 42.3022 295.165 54.5455 288.121L182.256 361.684Z",
    fill: "url(#paint36_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M182.257 362.611C170.044 369.655 151.563 370.412 140.976 364.326L51.5897 312.807C46.2032 309.717 43.8506 305.422 44.5626 301.035C45.0424 304.418 47.3332 307.601 51.5897 310.041L140.976 361.56C151.563 367.647 170.044 366.89 182.257 359.846V362.611Z",
    fill: "url(#paint37_radial)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.09
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1831 78.7848C12.9863 71.7559 3.0957 77.379 3.0957 91.3594V243.399C3.0957 257.379 12.9863 274.403 25.1831 281.432L212.965 389.598C225.162 396.627 239.51 390.309 239.51 376.329V224.274C239.51 210.371 225.162 193.98 212.965 186.952L25.1831 78.7848Z",
    fill: "#A7ADDF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.18
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9196 79.1864C12.7228 72.1576 2.84766 77.7806 2.84766 91.7302V242.858C2.84766 256.761 12.7228 273.754 24.9196 280.829L212.361 388.795C224.558 395.808 238.442 389.567 238.442 375.602V224.49C238.442 210.587 224.511 194.166 212.361 187.137L24.9196 79.1864Z",
    fill: "#A0A5D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.27
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6417 79.5723C12.4758 72.559 2.61621 78.182 2.61621 92.1161V242.379C2.61621 256.282 12.4758 273.275 24.6417 280.304L211.742 388.053C223.908 395.067 237.343 388.903 237.343 374.953V224.691C237.343 210.788 223.908 194.335 211.742 187.322L24.6417 79.5723Z",
    fill: "#989CD3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3782 79.9743C12.2278 72.961 2.36816 78.5686 2.36816 92.4872V241.746C2.36816 255.649 12.2278 272.642 24.3782 279.64L211.107 387.173C223.258 394.186 236.229 388.085 236.229 374.166V224.907C236.229 211.004 223.258 194.521 211.107 187.508L24.3782 79.9743Z",
    fill: "#9094CD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.45
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1305 80.3603C11.9801 73.3778 2.15137 78.97 2.15137 92.8732V241.174C2.15137 255.077 11.9801 272.07 24.1305 279.022L210.488 386.354C222.639 393.352 235.145 387.327 235.145 373.424V225.123C235.145 211.22 222.639 194.706 210.488 187.708L24.1305 80.3603Z",
    fill: "#898BC7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.55
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8358 80.7621C11.7164 73.7796 1.8877 79.3718 1.8877 93.2595V240.649C1.8877 254.552 11.7164 271.452 23.8358 278.435L209.868 385.551C221.988 392.549 234.045 386.601 234.045 372.714V225.386C234.045 211.483 221.988 194.938 209.868 187.94L23.8358 80.7621Z",
    fill: "#8183C1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.64
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5734 81.1637C11.4694 74.1812 1.65625 79.7734 1.65625 93.6303V240.093C1.65625 253.996 11.4694 270.865 23.5734 277.832L209.219 384.748C221.323 391.73 232.916 385.86 232.916 371.988V225.525C232.916 211.622 221.323 195.046 209.219 188.064L23.5734 81.1637Z",
    fill: "#7A7ABB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.73
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3099 81.55C11.2214 74.583 1.4082 80.1597 1.4082 94.0165V239.537C1.4082 253.44 11.2214 270.263 23.3099 277.23L208.584 383.945C220.688 390.912 231.801 385.119 231.801 371.262V225.742C231.801 211.838 220.673 195.216 208.584 188.249L23.3099 81.55Z",
    fill: "#7272B5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.82
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0474 81.9511C10.959 74.9841 1.17676 80.5608 1.17676 94.3095V238.918C1.17676 252.744 10.959 269.598 23.0474 276.565L207.966 383.048C220.039 390.015 230.719 384.299 230.719 370.473V225.942C230.719 212.039 220.039 195.401 207.966 188.434L23.0474 81.9511Z",
    fill: "#6A69AF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.91
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7685 82.338C10.7109 75.3864 0.928711 80.9632 0.928711 94.6964V238.363C0.928711 252.173 10.7109 269.012 22.7685 275.963L207.331 382.245C219.388 389.197 229.619 383.558 229.619 369.748V226.082C229.619 212.271 219.388 195.495 207.331 188.543L22.7685 82.338Z",
    fill: "#6361A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5822 82.7393C10.5402 75.8032 0.773438 81.349 0.773438 95.0977V237.822C0.773438 251.617 10.5402 268.44 22.5822 275.376L206.773 381.442C218.815 388.393 228.582 382.832 228.582 369.083V226.344C228.582 212.549 218.815 195.741 206.773 188.805L22.5822 82.7393Z",
    fill: "#5B58A3"
  })))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M228.443 224.969C228.443 211.066 218.645 194.259 206.557 187.292L21.8862 80.9167C9.79769 73.9497 0 79.5264 0 93.3832V122.843L228.443 254.351V224.969Z",
    fill: "url(#paint38_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8862 286.174L206.588 392.534C218.676 399.501 228.474 393.924 228.474 380.083V254.352L0 122.843V248.559C0 262.338 9.79769 279.207 21.8862 286.174Z",
    fill: "url(#paint39_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M21.8862 286.174L206.588 392.534C218.676 399.501 228.474 393.924 228.474 380.083V254.352L0 122.843V248.559C0 262.338 9.79769 279.207 21.8862 286.174Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M206.588 187.292L21.8862 80.9167C9.79769 73.9497 0 79.5264 0 93.3832V95.4842C0 81.581 9.79769 76.066 21.8862 83.0331L206.588 189.393C218.676 196.36 228.474 213.229 228.474 227.086V224.969C228.443 211.128 218.676 194.259 206.588 187.292Z",
    fill: "url(#paint40_radial)"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2586 298.795C42.4109 300.345 39.9011 302.446 37.8755 304.974H35.1514V322.091H35.2288C35.5693 325.628 37.8755 328.965 42.3023 331.514L131.689 383.017C142.276 389.119 160.757 388.347 172.969 381.318V365.716L45.2586 298.795Z",
    fill: "url(#paint41_linear)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M172.97 365.963C160.758 373.007 142.277 373.78 131.69 367.678L42.303 316.159C31.7159 310.072 33.0161 299.429 45.2594 292.384L172.97 365.963Z",
    fill: "url(#paint42_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M172.97 366.859C160.757 373.903 142.276 374.66 131.689 368.574L42.3026 317.055C36.9161 313.965 34.5635 309.67 35.2755 305.283C35.7553 308.666 38.046 311.849 42.3026 314.289L131.689 365.808C142.276 371.895 160.757 371.138 172.97 364.094V366.859Z",
    fill: "url(#paint43_radial)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3213 187.446L37.3484 191.509L42.7039 219.114H42.7967V194.706L47.7962 197.58V238.455L42.0383 235.134L35.3053 201.426H35.2124V231.256L30.3213 228.321V187.446Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8182 239.784C52.341 237.069 51.5894 234.021 51.6358 230.932V209.444C51.6358 206.185 52.3633 204.068 53.8182 203.126C55.2732 202.183 57.3937 202.492 60.1488 204.084C62.803 205.568 64.9899 207.761 66.464 210.417C67.9532 213.128 68.7106 216.178 68.6619 219.269V240.742C68.6619 244.017 67.9344 246.118 66.464 247.075C64.9935 248.033 62.904 247.709 60.1488 246.118C57.4939 244.629 55.3031 242.437 53.8182 239.784ZM63.1052 237.93V215.623C63.2035 214.496 62.9829 213.365 62.4685 212.357C61.954 211.349 61.1664 210.506 60.1953 209.923C58.2605 208.811 57.2854 209.583 57.2854 212.271V234.655C57.187 235.782 57.4076 236.914 57.9221 237.921C58.4365 238.929 59.2241 239.773 60.1953 240.355C62.0836 241.39 63.0587 240.603 63.0587 237.93H63.1052Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6172 219.995L70.751 216.612V210.772L88.0866 220.767V226.607L82.2203 223.224V258.244L76.6172 255.016V219.995Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9371 227.023L113.781 235.566V241.406L104.494 236.091V247.477L111.738 251.648V257.487L104.494 253.316V271.112L98.8906 267.883L98.9371 227.023Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M118.253 276.921C116.78 274.205 116.029 271.157 116.071 268.069V246.581C116.071 243.306 116.799 241.205 118.253 240.247C119.708 239.289 121.829 239.629 124.584 241.205C127.235 242.694 129.421 244.886 130.899 247.539C132.381 250.252 133.138 253.3 133.097 256.39V277.909C133.097 281.169 132.354 283.285 130.899 284.228C129.444 285.17 127.339 284.861 124.584 283.27C121.926 281.779 119.734 279.581 118.253 276.921ZM127.54 275.052V252.745C127.64 251.608 127.416 250.467 126.892 249.453C126.369 248.438 125.569 247.593 124.584 247.013C122.649 245.901 121.674 246.689 121.674 249.377V271.73C121.576 272.857 121.796 273.989 122.311 274.996C122.825 276.004 123.613 276.848 124.584 277.431C126.519 278.527 127.478 277.739 127.478 275.052H127.54Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M138.809 288.723C137.342 286.006 136.601 282.958 136.657 279.872V248.759L142.276 251.988V283.625C142.224 284.821 142.474 286.011 143.003 287.086C143.497 287.988 144.231 288.736 145.124 289.248C146.037 289.774 146.749 289.866 147.244 289.526C147.74 289.187 147.972 288.322 147.972 286.916V255.278L153.374 258.368V289.557C153.374 292.863 152.662 294.98 151.238 295.937C149.814 296.895 147.74 296.571 145.046 295.011C142.421 293.536 140.26 291.358 138.809 288.723Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M157.352 260.685L164.394 264.732L169.842 292.338H169.951V267.93L174.95 270.819V311.679L169.177 308.358L162.459 274.65H162.351V304.496L157.352 301.607V260.685Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M179.13 273.275L187.689 278.203C190.312 279.644 192.482 281.784 193.958 284.383C195.392 287.071 196.111 290.081 196.048 293.126V313.749C196.048 317.055 195.351 319.156 193.958 320.067C192.565 320.979 190.475 320.623 187.689 319.032L179.13 314.089V273.275ZM187.581 313.178C188.51 313.703 189.129 313.796 189.701 313.456C190.274 313.116 190.444 312.251 190.444 310.845V289.558C190.492 288.36 190.236 287.17 189.701 286.097C189.217 285.189 188.481 284.438 187.581 283.934L184.733 282.297V311.478L187.581 313.178Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M249.757 495C241.246 495.006 232.878 492.808 225.472 488.62L62.2543 395.7C60.2292 394.55 58.5407 392.892 57.3566 390.889C56.1724 388.886 55.5337 386.609 55.504 384.284C55.4743 381.958 56.0545 379.666 57.1871 377.633C58.3197 375.601 59.9652 373.9 61.9602 372.698L86.648 357.822C87.0138 357.607 87.4309 357.495 87.8553 357.498C88.2078 357.496 88.556 357.575 88.8731 357.729C89.1902 357.883 89.4678 358.107 89.6845 358.384C89.9012 358.662 90.0513 358.985 90.1233 359.329C90.1953 359.674 90.1872 360.03 90.0996 360.371C90.0308 360.667 89.9019 360.946 89.7209 361.19C89.5398 361.435 89.3105 361.64 89.0471 361.792L64.3748 376.669C63.0747 377.454 62.0026 378.565 61.2646 379.891C60.5265 381.217 60.1482 382.713 60.1669 384.229C60.1857 385.746 60.6009 387.232 61.3715 388.539C62.1421 389.847 63.2414 390.931 64.5606 391.684L227.794 484.588C234.46 488.365 241.991 490.36 249.656 490.382C257.322 490.403 264.863 488.45 271.551 484.712L285.125 477.08C285.468 476.88 285.858 476.774 286.255 476.772C286.77 476.768 287.272 476.936 287.681 477.249C288.09 477.562 288.384 478.001 288.515 478.499C288.646 478.996 288.608 479.523 288.406 479.996C288.204 480.469 287.851 480.862 287.4 481.112L273.826 488.744C266.475 492.857 258.185 495.012 249.757 495Z",
    fill: "#9094CD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M329.469 437.982C329.503 438.303 329.452 438.627 329.322 438.922C329.192 439.217 328.986 439.474 328.726 439.665L317.257 445.613C316.777 445.86 317.087 445.289 316.359 444.871C315.596 444.411 314.955 443.772 314.491 443.011C314.028 442.25 313.755 441.388 313.697 440.5C313.697 439.696 312.923 439.696 313.403 439.434L324.95 433.255C325.251 433.121 325.582 433.068 325.911 433.1C326.239 433.133 326.553 433.25 326.823 433.44C327.586 433.941 328.223 434.612 328.682 435.4C329.141 436.188 329.411 437.072 329.469 437.982Z",
    fill: "url(#paint44_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M344.529 451.422C344.561 451.744 344.508 452.069 344.375 452.364C344.241 452.66 344.033 452.915 343.77 453.105L332.301 459.038C331.821 459.3 332.131 458.713 331.403 458.311C330.64 457.851 329.999 457.212 329.535 456.451C329.072 455.69 328.799 454.828 328.741 453.94C328.741 453.136 327.967 453.136 328.447 452.858L339.994 446.679C340.297 446.549 340.628 446.499 340.956 446.534C341.285 446.57 341.598 446.689 341.867 446.88C342.634 447.378 343.274 448.048 343.736 448.836C344.198 449.625 344.47 450.51 344.529 451.422Z",
    fill: "url(#paint45_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M317.612 432.389C308.109 426.905 300.4 431.292 300.4 442.183C300.4 453.074 308.139 466.329 317.612 471.813C327.085 477.297 334.824 472.894 334.824 462.019C334.824 451.143 327.116 437.811 317.612 432.389ZM317.612 465.742C314.153 463.495 311.271 460.467 309.201 456.903C307.13 453.339 305.929 449.339 305.694 445.227C305.694 437.688 311.034 434.66 317.612 438.445C324.19 442.23 329.53 451.421 329.53 458.96C329.53 466.498 324.19 469.464 317.612 465.695V465.742Z",
    fill: "url(#paint46_linear)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M328.365 473.832C335.044 469.935 334.975 457.414 328.21 445.865C321.445 434.316 310.547 428.112 303.868 432.009C297.19 435.906 297.259 448.427 304.024 459.976C310.789 471.525 321.687 477.728 328.365 473.832Z",
    fill: "url(#paint47_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M328.355 463.795C328.355 468.429 326.73 471.812 324.099 473.419C324.022 473.419 296.238 479.83 296.238 479.861C294.412 480.834 295.573 478.61 292.802 477.08C287.214 473.991 282.679 466.545 282.679 460.412C282.679 457.322 279.738 457.322 281.534 456.349L302.476 436.529C305.293 434.984 309.039 435.278 313.156 437.657C321.561 442.492 328.355 454.186 328.355 463.795Z",
    fill: "url(#paint48_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M288.25 457.245C282.848 454.155 278.452 456.612 278.452 462.806C278.643 466.186 279.629 469.474 281.332 472.402C283.034 475.331 285.404 477.817 288.25 479.66C293.652 482.75 298.048 480.293 298.048 474.099C297.857 470.719 296.87 467.431 295.168 464.503C293.466 461.574 291.095 459.088 288.25 457.245Z",
    fill: "url(#paint49_linear)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M250.112 489.285C241.062 489.299 232.164 486.962 224.294 482.503L61.0296 389.583C58.5358 388.166 56.4567 386.122 54.9989 383.655C53.541 381.188 52.7551 378.383 52.7191 375.519C52.6831 372.655 53.3983 369.832 54.7937 367.329C56.1891 364.826 58.2161 362.731 60.6736 361.252L85.3614 346.375C85.9712 346.008 86.6475 345.764 87.3516 345.658C88.0558 345.552 88.774 345.585 89.4654 345.756C90.1567 345.926 90.8076 346.231 91.3808 346.653C91.9541 347.075 92.4385 347.605 92.8064 348.214C93.1743 348.822 93.4185 349.497 93.5251 350.2C93.6316 350.903 93.5984 351.62 93.4274 352.31C93.2563 353 92.9508 353.649 92.5282 354.221C92.1057 354.793 91.5743 355.277 90.9645 355.644L66.2768 370.521C65.4351 371.025 64.7406 371.741 64.2625 372.597C63.7845 373.453 63.5395 374.419 63.552 375.399C63.5645 376.379 63.8342 377.338 64.334 378.182C64.8338 379.025 65.5463 379.723 66.4006 380.206L229.618 473.126C235.824 476.631 242.83 478.48 249.96 478.497C257.09 478.513 264.104 476.695 270.326 473.219L283.9 465.587C285.15 464.923 286.61 464.773 287.969 465.17C289.327 465.566 290.476 466.478 291.17 467.709C291.864 468.941 292.047 470.394 291.681 471.759C291.314 473.123 290.427 474.291 289.21 475.011L275.635 482.642C267.841 487.009 259.05 489.297 250.112 489.285Z",
    fill: "url(#paint50_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.757 484.912C241.246 484.919 232.878 482.72 225.472 478.532L62.2543 385.659C60.2292 384.509 58.5407 382.85 57.3566 380.847C56.1724 378.844 55.5337 376.567 55.504 374.242C55.4743 371.917 56.0545 369.624 57.1871 367.592C58.3197 365.56 59.9652 363.858 61.9602 362.657L86.648 347.781C87.0138 347.566 87.4309 347.454 87.8553 347.456C88.2078 347.455 88.556 347.534 88.8731 347.687C89.1902 347.841 89.4678 348.065 89.6845 348.343C89.9012 348.62 90.0513 348.943 90.1233 349.288C90.1953 349.632 90.1872 349.989 90.0996 350.329C90.0308 350.626 89.9019 350.904 89.7209 351.149C89.5398 351.393 89.3105 351.598 89.0471 351.751L64.3748 366.627C63.0747 367.413 62.0026 368.523 61.2646 369.85C60.5265 371.176 60.1482 372.671 60.1669 374.188C60.1857 375.705 60.6009 377.19 61.3715 378.498C62.1421 379.805 63.2414 380.889 64.5606 381.643L227.794 474.547C234.46 478.323 241.991 480.319 249.656 480.34C257.322 480.362 264.863 478.409 271.551 474.67L285.125 467.039C285.468 466.839 285.858 466.732 286.255 466.73C286.77 466.727 287.272 466.895 287.681 467.208C288.09 467.52 288.384 467.96 288.515 468.457C288.646 468.954 288.608 469.481 288.406 469.954C288.204 470.428 287.851 470.82 287.4 471.071L273.811 478.733C266.456 482.817 258.173 484.945 249.757 484.912Z",
    fill: "url(#paint51_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M249.446 483.723C241.129 483.752 232.947 481.622 225.703 477.544L62.4848 384.5C60.6213 383.446 59.0672 381.922 57.9773 380.081C56.8875 378.241 56.3 376.147 56.2734 374.009C56.2468 371.871 56.782 369.764 57.8256 367.897C58.8693 366.03 60.385 364.468 62.2217 363.367L86.9094 348.491C87.0991 348.372 87.3202 348.313 87.5441 348.321C87.8118 348.325 88.0712 348.415 88.2832 348.578C88.4952 348.742 88.6484 348.969 88.7199 349.227C88.7914 349.484 88.7773 349.758 88.6797 350.007C88.5821 350.256 88.4063 350.467 88.1787 350.607L63.4909 365.484C62.0282 366.365 60.8218 367.613 59.9916 369.104C59.1613 370.594 58.7361 372.275 58.758 373.98C58.7799 375.686 59.2482 377.355 60.1165 378.824C60.9847 380.293 62.2227 381.509 63.7076 382.353L226.894 475.334C233.732 479.213 241.457 481.262 249.322 481.284C257.186 481.305 264.923 479.299 271.781 475.458L285.356 467.827C285.538 467.717 285.747 467.659 285.959 467.657C286.236 467.652 286.505 467.74 286.726 467.906C286.946 468.073 287.105 468.308 287.176 468.574C287.247 468.84 287.227 469.123 287.119 469.377C287.01 469.63 286.82 469.841 286.578 469.974L273.004 477.605C265.809 481.632 257.695 483.739 249.446 483.723Z",
    fill: "url(#paint52_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M346.977 174.346L387.576 149.815L393.984 243.121L346.977 252.189V174.346Z",
    fill: "url(#paint53_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M360.859 198.862L401.459 174.346V252.714L360.859 276.72V198.862Z",
    fill: "url(#paint54_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M311.174 166.885L351.773 142.354V220.721L311.174 244.727V166.885Z",
    fill: "url(#paint55_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M267.37 144.485L307.969 119.954V198.337L267.37 222.327V144.485Z",
    fill: "url(#paint56_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M252.946 119.428L293.546 94.897L299.954 188.203L252.946 197.271V119.428Z",
    fill: "url(#paint57_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M284.459 141.813L325.058 117.281L331.482 210.603L284.459 219.655V141.813Z",
    fill: "url(#paint58_radial)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M254.385 197.982L229.542 183.677V170.129L253.208 119.676L267.402 127.863V191.926L273.593 195.479V209.011L267.402 205.474V222.683L254.385 215.175V197.982ZM254.385 184.434V147.451L254.152 147.312L241.367 176.941L254.385 184.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M284.072 227.41C280.633 221.112 278.879 214.036 278.98 206.864V157.029C278.98 149.439 280.677 144.547 284.072 142.353C287.467 140.16 292.353 140.896 298.73 144.562C304.891 148.007 309.971 153.094 313.403 159.253C316.838 165.546 318.587 172.618 318.48 179.784V229.634C318.48 237.225 316.788 242.116 313.403 244.31C310.014 246.504 305.122 245.778 298.73 242.086C292.581 238.637 287.507 233.558 284.072 227.41ZM305.478 223.085V171.318C305.478 165.077 303.229 160.664 298.73 158.079C294.231 155.494 291.987 157.333 291.997 163.594V215.33C291.997 221.509 294.241 225.922 298.73 228.569C303.219 231.215 305.468 229.387 305.478 223.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M349.003 252.497L324.16 238.193V224.645L347.811 174.207L362.004 182.379V246.442L368.196 249.995V263.543L362.004 259.99V277.199L349.003 269.707V252.497ZM349.003 238.95V201.967L348.771 201.843L335.986 231.457L349.003 238.95Z",
    fill: "white"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5672 115.088L24.4704 150.618C22.5821 152.611 24.4704 157.987 27.7982 159.887L69.9918 184.202C73.2887 186.102 75.2235 182.951 73.3196 178.765L52.2228 118.981C50.5976 115.35 47.1924 113.389 45.5672 115.088Z",
    fill: "url(#paint59_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3204 178.703L52.2236 118.919C51.4832 117.183 50.1732 115.75 48.5088 114.856V171.751L69.9926 184.109C73.2894 186.04 75.2087 182.889 73.3204 178.703Z",
    fill: "url(#paint60_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9395 146.122V129.778L51.3104 132.868V149.196L50.6294 156.658L46.6205 154.341L45.9395 146.122ZM46.0323 158.481L51.2175 161.462V167.394L46.0323 164.413V158.481Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 371.786,
    y1: 366.318,
    x2: 491,
    y2: 366.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 374.573,
    y1: 365.083,
    x2: 487.595,
    y2: 365.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 57236.7,
    y1: 39210.5,
    x2: 65176.5,
    y2: 39210.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 403.766,
    y1: 397.971,
    x2: 426.96,
    y2: 439.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 386.368,
    y1: 407.348,
    x2: 414.156,
    y2: 446.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E2E5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 359.404,
    y1: 417.365,
    x2: 461.946,
    y2: 401.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(406.21 417.018) scale(9.53456 9.51597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11196.7 11160.2) scale(100.34 146.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 203.245,
    y1: 338.805,
    x2: 392.436,
    y2: 338.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 84507.7,
    y1: 27105.2,
    x2: 82167.7,
    y2: 34707.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 320.245,
    y1: 287.395,
    x2: 298.89,
    y2: 329.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#4D5A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6A75A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#979FC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#BDC2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#DADCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EEF0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FBFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 70383.9,
    y1: 58325.4,
    x2: 180559,
    y2: 76142.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 187.828,
    y1: 21.0869,
    x2: 433.481,
    y2: 391.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2F2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 250.964,
    y1: -34.3408,
    x2: 456.258,
    y2: 377.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 250.887,
    y1: -34.2791,
    x2: 456.165,
    y2: 377.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 250.794,
    y1: -34.202,
    x2: 456.057,
    y2: 377.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 250.717,
    y1: -34.1242,
    x2: 455.964,
    y2: 377.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BCC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7BDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 250.624,
    y1: -34.0631,
    x2: 455.872,
    y2: 377.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C1C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BEC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 250.546,
    y1: -33.9854,
    x2: 455.763,
    y2: 377.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BFC4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C2C8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 250.454,
    y1: -33.9233,
    x2: 455.67,
    y2: 378.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C4C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C6CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 250.375,
    y1: -33.8462,
    x2: 455.577,
    y2: 378.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C2C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C6CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CACEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B6BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 250.283,
    y1: -33.7692,
    x2: 455.485,
    y2: 378.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C3C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CDD2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B9C0E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 250.206,
    y1: -33.7072,
    x2: 455.376,
    y2: 378.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C5CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D0D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D1D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#BDC3EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 250.113,
    y1: -33.6301,
    x2: 455.284,
    y2: 378.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D3D7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D5D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C1C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 250.036,
    y1: -33.553,
    x2: 455.191,
    y2: 378.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D5D9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D9DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C5CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 249.943,
    y1: -33.4915,
    x2: 455.082,
    y2: 378.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CED3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D8DCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DDE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C9CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 249.865,
    y1: -33.4141,
    x2: 454.99,
    y2: 378.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D0D4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DADEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E1E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CDD1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 249.773,
    y1: -33.3369,
    x2: 454.897,
    y2: 378.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D1D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D2D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DDE1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E4E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D0D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 249.695,
    y1: -33.2749,
    x2: 454.804,
    y2: 378.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CFD3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D5DAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E8EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D4D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 249.602,
    y1: -33.1977,
    x2: 454.696,
    y2: 378.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E2E6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 249.525,
    y1: -33.1361,
    x2: 454.603,
    y2: 378.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D2D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D6DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E5E8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F0F1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#DCDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 249.432,
    y1: -33.0583,
    x2: 454.51,
    y2: 378.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D8DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DCE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E0E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 249.355,
    y1: -32.9811,
    x2: 454.402,
    y2: 378.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EAEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E3E6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 249.262,
    y1: -32.9195,
    x2: 454.309,
    y2: 378.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D6DBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E1E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ECEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E7EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B5BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 118921,
    y1: 20790.5,
    x2: 177766,
    y2: 106404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 85.7189,
    y1: 338.095,
    x2: 223.537,
    y2: 338.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BAC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C5CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D1D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 48761.3,
    y1: 21311,
    x2: 47986.2,
    y2: 24784.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47405.7 20034.6) scale(4830.53 2362.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 178.077,
    y1: 132.745,
    x2: 20.348,
    y2: 221.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7374F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9A70F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 95287.3,
    y1: 58888,
    x2: 67662.8,
    y2: 67530.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7374F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9A70F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.229 152.503) scale(210.597 210.185)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6C1E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#431233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#200918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 44108,
    y1: 26635.7,
    x2: 56379.3,
    y2: 26635.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BAC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C5CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D1D6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 47925.1,
    y1: 21537.8,
    x2: 47149.7,
    y2: 25011.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46569.5 20224.2) scale(4830.53 2362.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 319.579,
    y1: 435.572,
    x2: 323.668,
    y2: 442.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#626FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8B95CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A4ACDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#8791C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5865A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#495798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4B599A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5360A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#606CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#636FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 8234.31,
    y1: 5060.03,
    x2: 8262.79,
    y2: 5126.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#626FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8B95CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A4ACDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#8791C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5865A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#495798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4B599A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#5360A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#606CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#636FAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 16356.6,
    y1: 16136.8,
    x2: 17195.3,
    y2: 17058.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E2E5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 2888.09,
    y1: 118087,
    x2: 4845.79,
    y2: 117900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 22086.5,
    y1: 16477.4,
    x2: 22725.6,
    y2: 17707.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EFF2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EBEDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 9121.28,
    y1: 10123.1,
    x2: 9460.37,
    y2: 9822.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 72866,
    y1: 50107.5,
    x2: 109833,
    y2: 50107.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 71443.5,
    y1: 47841.5,
    x2: 106542,
    y2: 47841.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 70903.3,
    y1: 47119.1,
    x2: 105356,
    y2: 47119.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F5F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.125 173.28) scale(72.9333 72.7909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#9155BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6B3E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4A2B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2F1C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#1B0F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#0C070F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#030204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.413 275.113) scale(68.3518 68.2183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#63C6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4C98BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#386F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#274D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#19313E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0E1C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#060C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7805.82 16254) scale(1792.87 4520.83)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#63C6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4C98BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#386F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#274D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#19313E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0E1C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#060C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#020304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.924 220.736) scale(68.3518 68.2183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#6655BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4B3E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#342B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#211C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#130F23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#08070F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(224.095 118.362) scale(72.9333 72.7909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#00BDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#008B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00605F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#003E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#002322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#000F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#000404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.608 140.747) scale(72.9334 72.7909)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3F659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8ABD44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#658B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#466023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2D3E16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#19230C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0B0F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 23.7274,
    y1: 149.583,
    x2: 74.0626,
    y2: 149.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFC27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 7760.11,
    y1: 12200.5,
    x2: 8182.04,
    y2: 12200.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFC27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FFE585"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.cbbeeafb0c7bcc68aa467133b2765374.svg";
export { ForwardRef as ReactComponent };